/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {
  production: true,
  apiPath: 'https://fourelagadec.newm.fr/api/',
  apiPathV2: 'https://fourelagadec.newm.fr/api/v2/',
  serverUrl: 'https://fourelagadec.newm.fr',

  agGridLicenceKey: 'Using_this_{AG_Charts_and_AG_Grid}_Enterprise_key_{AG-074596}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Four_Lagadec}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{NewM}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{NewM}_need_to_be_licensed___{NewM}_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Charts_and_AG_Grid}_Enterprise_versions_released_before_{7_February_2026}____[v3]_[0102]_MTc3MDQyMjQwMDAwMA==bb4a8517d853f6a0a0486f714d14deb8'
};
